import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 17.5001C14.1421 17.5001 17.5 14.1423 17.5 10.0001C17.5 5.85799 14.1421 2.50012 10 2.50012C5.85786 2.50012 2.5 5.85799 2.5 10.0001C2.5 14.1423 5.85786 17.5001 10 17.5001Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 10.0001H17.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 17.2988C11.7259 17.2988 13.125 14.031 13.125 10.0001C13.125 5.96914 11.7259 2.70142 10 2.70142C8.27411 2.70142 6.875 5.96914 6.875 10.0001C6.875 14.031 8.27411 17.2988 10 17.2988Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGlobe;
